import React from 'react';
import {
  FaHardHat,
  FaFirstAid,
  FaTrafficLight,
  FaFireExtinguisher,
} from 'react-icons/fa';
// import Breadcrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component.jsx';
import { MdHealthAndSafety, MdOutlineCleaningServices } from 'react-icons/md';

import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component.jsx';

import {
  Section,
  Container,
  SectionIntro,
  Badge,
  BadgeDot,
  Eyebrow,
  Title,
  Description,
  CategoryGrid,
  CategoryCard,
  CategoryIcon,
  CategoryContent,
  CategoryEyebrow,
  CategoryTitle,
  CategoryDescription,
  CategoryAction,
  ButtonContainer,
} from './Products.styles.jsx';

const productCategories = [
  {
    eyebrow: 'Personal Protection',
    name: 'PPE',
    description:
      'Essential protective equipment for everyday workplace and job-site safety.',
    icon: <MdHealthAndSafety />,
  },
  {
    eyebrow: 'Emergency Preparedness',
    name: 'First Aid',
    description:
      'Workplace first aid kits, replacement supplies, and emergency essentials.',
    icon: <FaFirstAid />,
  },
  {
    eyebrow: 'Work-Zone Safety',
    name: 'Traffic Control',
    description:
      'Visibility and traffic-control products for safer work areas and job sites.',
    icon: <FaTrafficLight />,
  },
  {
    eyebrow: 'Work at Heights',
    name: 'Fall Protection',
    description:
      'Protective equipment designed to support safer work at elevated heights.',
    icon: <FaHardHat />,
  },
  {
    eyebrow: 'Fire Preparedness',
    name: 'Fire Safety',
    description:
      'Reliable fire prevention, protection, and emergency response equipment.',
    icon: <FaFireExtinguisher />,
  },
  {
    eyebrow: 'Hazard Response',
    name: 'Spill Response',
    description:
      'Absorbents, containment products, and supplies for workplace spill response.',
    icon: <MdOutlineCleaningServices />,
  },
];

const ProductsSection = () => {
  const handleProductsClick = () => {
    window.location.href = '/shop';
  };

  return (
    <Section>
      <Container>
        <SectionIntro>
          <Badge>
            <BadgeDot />
            New
          </Badge>

          <Eyebrow>Safety Products</Eyebrow>

          <Title>The Right Equipment. The Right Protection.</Title>

          <Description>
            Browse workplace safety supplies and equipment designed to help
            protect your team, support workplace compliance, and keep everyday
            operations moving.
          </Description>
        </SectionIntro>

        <CategoryGrid aria-label="Available safety product categories">
          {productCategories.map((category) => (
            <CategoryCard key={category.name}>
              <CategoryIcon aria-hidden="true">{category.icon}</CategoryIcon>

              <CategoryContent>
                <CategoryEyebrow>{category.eyebrow}</CategoryEyebrow>

                <CategoryTitle>{category.name}</CategoryTitle>

                <CategoryDescription>
                  {category.description}
                </CategoryDescription>

                <CategoryAction>
                  Explore category
                  <span aria-hidden="true">→</span>
                </CategoryAction>
              </CategoryContent>
            </CategoryCard>
          ))}
        </CategoryGrid>

        <ButtonContainer>
          <PrimaryButton
            functionName={handleProductsClick}
            span="Explore All Products"
          />
        </ButtonContainer>
      </Container>
    </Section>
  );
};

export default ProductsSection;
